import type { ReactNode } from "react";

export const SectionHeading = ({ icon, children, action }: { icon: ReactNode; children: ReactNode; action?: ReactNode }) => (
  <div className="flex items-center justify-between mb-0 py-2 border-y border-gray-200">
    <h3 className="flex items-center gap-2 text-[17px] font-semibold text-gray-600">
      <span className="text-muted-foreground">{icon}</span>
      {children}
    </h3>
    {action}
  </div>
);
